module.exports = __webpack_public_path__ + "img/top_tray_2x.png?8a8dc5fecdd6de28172cd8d660c16651";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/top_tray_2x.png
// module id = 309
// module chunks = 0